import { DbKey } from '../adl-gen/common/db';
import {
  AppClient,
  AppUser,
  Competency,
  Question,
  Quiz,
  Skill,
  TrainingOffering,
  UserGroup,
  UserQuiz,
  UserUploadSet,
  WorkRole
} from '../adl-gen/totalinteraction/futurefit/db';
import * as ST from '../admin/stores';
import { Service } from '../service/service';

import { LoggedIn, LoggedInSuper } from './identity-store';
import { ManagerPortalStore } from './manager-portal-store';
import { ManagerQuizResultsStore, Settings } from './manager-quiz-results-store';
import { PlotKeyToggleState } from './plot-key-toggle-state';
import { QuizResultsStore } from './quiz-results-store';
import { QuizStore } from './quiz-store';
import { UserQuizDataStore } from './user-quiz-data-store';

export class StoreFactory {
  constructor(private readonly service: Service) {}

  makeQuizStore(userQuizId: DbKey<UserQuiz>, identity: LoggedIn): QuizStore {
    return new QuizStore(this.service, userQuizId, identity);
  }

  makeQuizResultsStore(
    quizId: DbKey<Quiz>,
    userQuizId: DbKey<UserQuiz>,
    identity: LoggedIn,
    settings?: Omit<Settings, 'filters'> //Settings
    // rolesSelected?: string[]
  ): QuizResultsStore {
    return new QuizResultsStore(
      this.service,
      quizId,
      userQuizId,
      identity,
      // rolesSelected
      settings
    );
  }

  makePlotKeyToggleStore(): PlotKeyToggleState {
    return new PlotKeyToggleState();
  }

  makeUserQuizDataStore(identity: LoggedIn): UserQuizDataStore {
    return new UserQuizDataStore(this.service, identity);
  }

  makeManagerPortalStore(identity: LoggedIn): ManagerPortalStore {
    return new ManagerPortalStore(this.service, identity);
  }

  makeManagerQuizResultsStore(identity: LoggedIn, quizId: DbKey<Quiz>, settings?: Settings): ManagerQuizResultsStore {
    return new ManagerQuizResultsStore(this.service, identity, quizId, settings);
  }

  makeAppClientStore(identity: LoggedIn | LoggedInSuper, selectedClient?: DbKey<AppClient>): ST.AppClientStore {
    const appStore = ST.AppClientStore.fromService(this.service, identity, selectedClient);
    return appStore;
  }

  makeAppUserStore(
    identity: LoggedIn | LoggedInSuper,
    appClientId: DbKey<AppClient>,
    selectedUser?: DbKey<AppUser>
  ): ST.AppUserStore {
    const userStore = ST.AppUserStore.fromService(this.service, identity, appClientId, selectedUser);
    return userStore;
  }

  makeAppUserUploadStore(
    identity: LoggedIn | LoggedInSuper,
    appClientId: DbKey<AppClient>,
    id?: DbKey<UserUploadSet>
  ): ST.AppUserUploadStore {
    return ST.AppUserUploadStore.fromService(this.service, identity, appClientId, id);
  }

  makeCompetencyStore(identity: LoggedIn | LoggedInSuper, selectedCompetency?: DbKey<Competency>): ST.CompetencyStore {
    const store = ST.CompetencyStore.fromService(this.service, identity, selectedCompetency);
    return store;
  }

  makeQuestionStore(
    identity: LoggedIn | LoggedInSuper,
    skillId?: DbKey<Skill>,
    id?: DbKey<Question>
  ): ST.QuestionStore {
    return ST.QuestionStore.fromService(this.service, identity, skillId, id);
  }

  makeQuizAdminStore(
    identity: LoggedIn | LoggedInSuper,
    appClientId?: DbKey<AppClient>,
    workRoleId?: DbKey<WorkRole>
  ): ST.QuizAdminStore {
    return ST.QuizAdminStore.fromService(this.service, identity, appClientId, workRoleId);
  }

  makeReportStore(identity: LoggedIn | LoggedInSuper, appClientId?: DbKey<AppClient>): ST.ReportPortalStore {
    return ST.ReportPortalStore.fromService(this.service, identity, appClientId);
  }

  makeSkillStore(identity: LoggedIn | LoggedInSuper, selectedSkill?: DbKey<Skill>): ST.SkillStore {
    const store = ST.SkillStore.fromService(this.service, identity, selectedSkill);
    return store;
  }

  makeTrainingOfferingStore(identity: LoggedIn | LoggedInSuper, selectedTrainingOffering?: DbKey<TrainingOffering>): ST.TrainingOfferingStore {
    return ST.TrainingOfferingStore.fromService(this.service, identity, selectedTrainingOffering);
  }

  makeUserGroupStore(
    identity: LoggedIn | LoggedInSuper,
    appClientId: DbKey<AppClient>,
    selectedGroup?: DbKey<UserGroup>
  ): ST.UserGroupStore {
    const groupStore = ST.UserGroupStore.fromService(this.service, identity, appClientId, selectedGroup);
    return groupStore;
  }

  /// TODO: appClientId for future use by client admin, although server already filters on appClient
  makeWorkRoleStore(
    identity: LoggedIn | LoggedInSuper,
    appClientId?: DbKey<AppClient>,
    selectedRole?: DbKey<WorkRole>
  ): ST.WorkRoleStore {
    const roleStore = ST.WorkRoleStore.fromService(this.service, identity, appClientId, selectedRole);
    return roleStore;
  }

}



// WEBPACK FOOTER //
// ./src/stores/store-factory.ts